import axios from "axios";
const instance = axios.create({
  baseURL: `${process.env.PUBLIC_URL}/api`,
  //baseURL: `http://192.168.99.181/api`,
});
instance.defaults.withCredentials = true;
export default instance;
